<template>
  <div class="bg-primary/10 rounded-xl px-3 py-1.5 inline-flex items-center gap-2 sm:gap-3">
    <span class="text-xs sm:text-sm uppercase tracking-wide text-text-secondary">Room Code</span>
    <span class="text-xl font-bold tracking-widest text-text-primary leading-none select-all">
      {{ code }}
    </span>
    <CopyIconButton
      :text="code"
      subject="room code"
    />
  </div>
</template>

<script setup lang="ts">
import CopyIconButton from '@/components/shared/CopyIconButton.vue';

defineProps<{
  code: string;
}>();
</script>
